export default __webpack_public_path__ + "static/media/beep3.ac672fd3.mp3";